var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 31,
    fill: "none",
    className: "social-link"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M28.6279 8.7573c-.3271-1.2318-1.291-2.202-2.5148-2.5311-2.2182-.5983-11.113-.5983-11.113-.5983s-8.8948 0-11.1131.5983c-1.2238.3292-2.1877 1.2993-2.5148 2.531-.5944 2.2328-.5944 6.891-.5944 6.891s0 4.6583.5944 6.8909c.3271 1.2318 1.291 2.1615 2.5148 2.4907 2.2183.5982 11.1131.5982 11.1131.5982s8.8948 0 11.113-.5982c1.2238-.3292 2.1877-1.2589 2.5148-2.4907.5944-2.2326.5944-6.8909.5944-6.8909s0-4.6582-.5944-6.8908ZM12.091 19.8775v-8.4587l7.4343 4.2294-7.4343 4.2293Z"
  })));
};
export default SvgYoutube;